// extracted by mini-css-extract-plugin
export default {"tag":"AppTag_tag__GatkI","danger":"AppTag_danger__H4gU2","outlined":"AppTag_outlined__ZG0RY"};